import Vue from 'vue'
import Router from 'vue-router'
import rwConfig from '../assets/js/rwConfig.js'
import rwJS from '@/assets/js/rwJS.js'
var rwJsObj = new rwJS();
Vue.use(Router)
var rootDirRouter = {
  path: '/',
}
if (rwConfig.RootDirName === '') {
  rootDirRouter.component = resolve => (require(["@/pages/auto/admin"], resolve));
} else {
  rootDirRouter.redirect = '/' + rwConfig.RootDirName;
}

var router = {
  mode: 'history',
  routes: [
    rootDirRouter
    ,
    {
      path: '/' + rwConfig.RootDirName,
      name: rwConfig.RootDirName,
      component: resolve => (require(["@/pages/auto/admin"], resolve)),
    },
    // 404界面，需要放到最底部
    {
      path: "/404",
      component: resolve => (require(["@/pages/comm/404"], resolve))
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
};
export default new Router(router)



// WEBPACK FOOTER //
// ./src/router/index.js